module.exports = __webpack_public_path__ + "static/c3cLogo-90fb9ec53a6c275eb53db82406cc49d1.svg";